<template>
  <select v-model="selected">
    <option></option>
    <option v-for="year of years" :key="year" :value="year" >
        {{ year }}
    </option>
  </select>
</template>

<script lang="ts">
import moment from 'moment'
import _ from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class FiscalYearInput extends Vue {
  @Prop() value!: number

  private years: number[] = (() => {
    const startYear = 2020
    const endYear = moment().add(1, 'years').get('year')

    // 開始年〜終了年までの配列を作成
    return _.range(startYear, endYear + 1)
  })()

  private get selected(): number {
    return this.value
  }

  private set selected(year: number) {
    this.$emit('input', year || null)
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
